<!-- Copyright (c) 2025 Digital Systems (M) Sdn. Bhd. -->

<template>
  <div class="import-main">
    <div style="display: flex; width: 100%; height: fit-content">
      <div class="top-section" style="width: 90%; margin-right: 5px; height: auto">
        <div style="display: flex">
          <Dropdown
            ref="doctype"
            placeholder="Document Type"
            :isRequired="true"
            :items="documentTypeFilter"
            itemKey="placeholder"
            :selectedObject.sync="selectedDocumentType"
            style="width: 25%"
            :isDisabled="importDoc['docName'] !== ''"
          />
          <InputQuery
            ref="payeetype"
            placeholder="Payee Type"
            :isRequired="true"
            :items="payeeTypeList"
            itemKey="Party"
            :selectedObject.sync="selectedPayeeType"
            :errorMessage.sync="payeeTypeErr"
            @selected="payeeTypeSelected"
            style="width: calc(100% / 4)"
          />
          <InputQuery
            v-if="selectedDocumentType && selectedDocumentType['name'] == 'PDF'"
            placeholder="Payee Code"
            :items="payeeCodeList"
            itemKey="Code - Name"
            :selectedObject.sync="selectedPayeeCode"
            :errorMessage.sync="payeeCodeErr"
            :isRequired="true"
            :isDisabled="!selectedPayeeType"
            :tableBoxHideColumns="['Code - Name']"
            style="width: calc(100% / 4)"
          />
        </div>
        <!-- <div style="display: flex">
          <div class="file-input" style="width: 30%">
            <div>
              <div v-if="showPDFButtons" style="display: flex; margin-top: 5px">
                <button
                  v-if="excelEnabled && !csvEnabled"
                  @click="downloadExportExcel"
                  :disabled="disableDownloadExport"
                  >Export to Excel</button
                >
              </div>
            </div>
          </div>
        </div> -->
      </div>
      <div class="top-section" style="width: 10%; height: auto; display: flex; flex-direction: column">
        <div>
          Download Template
          <div style="display: flex">
            <a
              href="/ImportTemplates/ImportAPInvoiceExcel.xlsx"
              download="APInvoiceTemplate.xlsx"
              style="align-content: center; margin-left: 10px"
              ><Tooltip
                icon="https://dsmapi.logistics.systems/dsm6gIcons/ExportExcel.png"
                tooltipText="Download Excel Template"
                style="cursor: pointer"
            /></a>
            <a
              href="/ImportTemplates/ImportAPInvoiceCSV.csv"
              download="APInvoiceTemplate.csv"
              style="align-content: center; margin-left: 10px"
              ><Tooltip
                icon="https://dsmapi.logistics.systems/dsm6gIcons/ExportCSV.png"
                tooltipText="Download CSV Template"
                style="cursor: pointer"
            /></a>

            <a
              href="/ImportTemplates/ImportAPInvoiceTxt.txt"
              download="APInvoiceTemplate.txt"
              style="align-content: center; margin-left: 10px"
              ><Tooltip
                icon="https://dsmlib.logistics.systems/Icons/TXTFile.png"
                tooltipText="Download Txt Template"
                style="cursor: pointer"
            /></a>
          </div>
        </div>
        <button @click="customTemplateClicked" style="margin-top: 10px">Custom Templates</button>
      </div>
    </div>

    <div class="bottom-section">
      <div class="top-div" id="top-section" :class="{ 'fullscreen-mode': isValidatedFullscreen }">
        <div
          class="table-container top-left-div"
          id="left-pane"
          :style="topLeftDivWidth"
          v-show="!isValidatedFullscreen"
        >
          <div style="display: flex" id="file-input">
            <Input
              textType="file"
              placeholder="Select File"
              :inputValue.sync="importDoc['docName']"
              @fileChanged="handleFileUpload"
              style="width: fit-content; margin-right: 5px"
              :isDisabled="selectFileDisabled"
            />
          </div>
          <iframe class="pdf-display" v-if="showPDF && embedSrc" type="video/webm" :src="embedSrc"></iframe>
          <TableBox
            title="Uploaded Data"
            :tableData="uploadedData"
            v-else-if="showUploadedDataTable"
            :loading="!showUploadedDataTable"
            style="height: calc(100% - 25px); overflow: scroll"
            :rowHeight="35"
            groupBy="InvNo"
          />
        </div>
        <div class="resizer-x" id="resizer-x" v-show="!isValidatedFullscreen"></div>
        <div
          class="table-container top-right-div"
          id="right-pane"
          :style="topRightDivWidth"
          :class="{ 'fullscreen-pane': isValidatedFullscreen }"
        >
          <div style="display: flex; margin-top: 5px; justify-content: flex-end">
            <img
              class="icon-btn"
              :src="
                isValidatedFullscreen ?
                  'https://dsmlib.logistics.systems/Icons/Collapse.png'
                : 'https://dsmlib.logistics.systems/Icons/Expand.png'
              "
              :title="isValidatedFullscreen ? 'Collapse View' : 'Expand View'"
              height="20"
              width="20"
              @click="toggleValidatedFullscreen"
              style="display: flex; margin-top: 5px; margin-right: 5px"
            />
            <button
              @click="revalidateDataClicked"
              :disabled="disableValidateButton"
              class="import-button"
              style="margin-right: 3px"
              >Revalidate Data</button
            >
            <!-- v-if="showPDFButtons" -->
            <div class="export-dropdown" style="margin-right: 3px" ref="exportDropdown">
              <button class="import-button" :disabled="disableDownloadExport" @click="toggleExportMenu">
                Export to ... ▾
              </button>

              <div v-if="showExportMenu" class="export-menu">
                <div @click="exportFile('csv')">CSV</div>
                <div @click="exportFile('excel')">Excel</div>
              </div>
            </div>
            <button @click="saveAPINClicked" :disabled="disableImportButton" class="import-button"
              >Save AP Invoice</button
            >
          </div>
          <TableBox
            title="Validated Data"
            :tableData="validatedData"
            v-if="showValidatedDataTable"
            :loading="!showValidatedDataTable"
            style="height: calc(100% - 25px); overflow: scroll"
            groupBy="InvNo"
            :additionalIconsIndex="additionalIconIndex"
            :dataType="templateDataType"
            :hideColumns="['Error', 'InvNo', 'NewJobChrg']"
            :rowHeight="35"
          />
        </div>
      </div>
      <div class="resizer-y" id="resizer-y"></div>
      <div class="bottom-div" id="bottom-section" v-show="!isValidatedFullscreen">
        <div class="table-container" style="display: flex">
          <TableBox
            title="Imported Successfully"
            v-if="showSuccessInv"
            :tableData="importSuccessInv"
            :additionalButtons="importSuccessInvTableBtn"
            @buttonClicked="importSuccessButtonClicked"
            style="height: 100%; overflow: scroll; width: 50%"
          />
          <div class="message-container" :style="messageBoxStyle" v-html="messageBoxText"></div>
        </div>
      </div>
    </div>

    <TemplateMapping
      :showPopup.sync="showMappingPopup"
      :targetFields="defaultTemplate"
      :sourceFields="sourceFields"
      :mappedFields.sync="mappedFields"
      :templateName.sync="customTemplateName"
      :successMessages="successMessages"
      :errorMessages="errorMessages"
      :disableTemplateName="disableTemplateName"
      :viewMode="templateMappingViewMode"
      @saveMappingClicked="saveMappingClicked"
    />

    <div v-if="showSelectCustomTemplate" class="custom-template-popup">
      <div class="select-container">
        <div class="title">Select Custom Template</div>
        <div>
          <CheckBoxV2
            title="Use Existing Custom Template"
            :isChecked.sync="useExistingTemplateChecked"
            @checkBoxClicked="customTemplateChecked($event, 'existing')"
          />
          <Dropdown
            placeholder="Custom Template"
            :items="customTemplateList"
            itemKey="Template Name"
            :selectedObject.sync="selectedExistingTemplate"
            :errorMessage.sync="existingTemplateErr"
            :isDisabled="!useExistingTemplateChecked"
            :isRequired="useExistingTemplateChecked"
            style="z-index: 999"
          />

          <CheckBoxV2
            title="Create New Custom Template"
            :isChecked.sync="createNewTemplateChecked"
            @checkBoxClicked="customTemplateChecked($event, 'new')"
            style="margin-top: 5px"
          />
        </div>
        <div class="continue-buttons">
          <button @click="customTemplateButtonClicked('continue')">Continue</button>
          <button @click="customTemplateButtonClicked('cancel')" style="background-color: lightgray">Cancel</button>
        </div>
      </div>
    </div>

    <div v-if="showCustomTemplateListPopup" class="template-list-popup">
      <div class="popup-content">
        <div class="call-to-action-buttons">
          <!-- <button>
            <img src="https://dsmapi.logistics.systems/dsm6gicons/icons8-add-new-50.png" alt="New Template">
            New Template
          </button> -->
          <button @click="templateListActionButtonClicked('edit')">
            <img src="https://dsmlib.logistics.systems/Icons/icons8-edit-64%20(1).png" alt="Edit Template" />
            Edit Template
          </button>
          <button @click="templateListActionButtonClicked('delete')">
            <img src="https://dsmlib.logistics.systems/Icons/icons8-reduce-50.png" alt="Delete Template" />
            Delete Template
          </button>
        </div>
        <div class="main-content">
          <TableBox
            v-if="showCustomTemplateList"
            title="Custom Templates"
            :tableData="customTemplateList"
            :selectedRow.sync="selectedCustomTemplate"
            :dataType="{ 'Date Updated': 'datetime' }"
          />
          <div class="call-to-action-buttons">
            <button @click="customTemplateListCloseClicked">
              <img src="https://dsmlib.logistics.systems/Icons/Cancel.png" alt="Close" />
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Axios from 'axios';

export default {
  components: {},
  computed: {
    topLeftDivWidth: function () {
      return {
        width: this.uploadedData.length > 0 ? 'calc(50% - 2.5px)' : '100%',
      };
    },

    topRightDivWidth: function () {
      return {
        width: this.validatedData.length > 0 ? 'calc(50% - 2.5px)' : '100%',
      };
    },

    documentTypeFilter: function () {
      const docTypeList = this.documentType.filter((doc) => !doc.hide);
      return docTypeList;
    },

    additionalIconIndex: function () {
      if (this.validatedData.length > 0 && this.validatedData.some((data) => data['Error'] == '1')) {
        return [0];
      }
      return [];
    },

    disableImportButton: function () {
      return (
        this.importDoc['docName'] == '' ||
        this.messageBoxType == 'error' ||
        !this.selectedPayeeType ||
        this.validatedData.some((data) => data['Error'] == '1') ||
        this.validatedData.length == 0
      );
    },

    disableValidateButton: function () {
      return this.validatedData.length == 0;
    },

    disableDownloadExport: function () {
      return this.validatedData.length == 0; //&& this.selectedDocumentType && this.selectedDocumentType['name'] == 'PDF' ;
    },

    selectFileDisabled: function () {
      if (!this.selectedDocumentType || !this.selectedPayeeType) {
        return true;
      } else if (
        this.selectedDocumentType['name'] == 'PDF' &&
        !this.selectedPayeeCode &&
        this.validatedData.length == 0
      ) {
        return true;
      }
      return false;
    },

    messageBoxStyle: function () {
      const style = {
        width: '50%',
        backgroundColor: 'rgba(255, 246, 121, 0.4)',
      };
      switch (this.messageBoxType) {
        case 'success':
          style['backgroundColor'] = 'rgba(50, 205, 50, 0.4)';
          break;

        case 'import error':
        case 'error':
          style['backgroundColor'] = 'rgba(205, 92, 92, 0.4)';
          break;

        default:
          style['backgroundColor'] = 'rgba(255, 246, 121, 0.4)';
          break;
      }
      return style;
    },

    showPDF: function () {
      return this.selectedDocumentType && this.selectedDocumentType['name'] === 'PDF' && this.embedSrc;
    },

    // showPDFButtons: function () {
    //   return this.selectedDocumentType && this.selectedDocumentType['name'] === 'PDF';
    // },

    // csvEnabled: function () {
    //   const csv = this.documentType.find((doc) => doc['name'] == 'CSV');
    //   return !csv?.hide;
    // },

    // excelEnabled: function () {
    //   const excel = this.documentType.find((doc) => doc['name'] == 'Excel');
    //   return !excel?.hide;
    // },

    disableTemplateName: function () {
      return this.saveCustomTemplateAction == 'E';
    },
  },
  data: function () {
    return {
      //#region preset/default values
      localCurrency: '',
      dgcCode: '',
      tollCode: '',
      dieselCode: '',
      //#endregion

      documentType: [
        // combine csv excel txt
        { placeholder: 'CSV', name: 'CSV', type: ['.csv'], key: 'Import_CSV', hide: true },
        { placeholder: 'Excel', name: 'Excel', type: ['.xlsx', '.xls'], key: 'Import_Excel', hide: true },
        { placeholder: 'Text', name: 'Text', type: ['.txt'], key: 'Import_Text', hide: true },
        { placeholder: 'Doc AI (PDF)', name: 'PDF', type: ['.pdf'], key: 'Import_DocAI', hide: true },
      ],
      payeeTypeList: [],
      payeeCodeList: [],
      payeeCodeKey: null,
      expenseCodeList: [],
      currencyList: [],

      selectedDocumentType: null,
      selectedPayeeType: null,
      payeeTypeErr: '',
      selectedPayeeCode: null,
      payeeCodeErr: '',

      importDoc: {
        docName: '',
        attachmentFile: [],
        filetype: '',
        docGuid: '',
        remarks: '',
        docID: 0,
        original: [],
      },

      embedSrc: '',
      // scannedData: [],

      uploadedData: [], // Data that will show at the left table box (Uploaded Data table), data is exactly same as the data in the file uploaded by users
      showUploadedDataTable: true,
      importDataHeader: [],
      formattedUploadData: [], // Data used when export to CSV / revalidate. Data that are formatted and mapped into default template
      validatedData: [], // Data that is validated, will show error and warnings (where applicable)
      showValidatedDataTable: true,

      showSuccessInv: true,
      importSuccessInv: [],
      importSuccessInvTableBtn: [
        { text: 'Edit', index: 0, width: 60 },
        { text: 'View', index: 1, width: 60 },
      ],

      messageBoxTextList: [],
      messageBoxText: '',
      messageBoxType: '',

      // templateFields: [
      //   // 'I',
      //   'InvNo',
      //   // 'InvDate',
      //   'PaymentTerms',
      //   // 'DueDate',
      //   // 'JobNo',
      //   // 'CNNo',
      //   // 'ContNo',
      //   // 'CustRefNo',
      //   'Currency',
      //   // 'ChargesCode',
      //   // 'UOM',
      //   // 'Qty',
      //   // 'UnitPrice',
      //   // 'ChargesAmt',
      //   // 'AdjustAmt',
      //   // 'TaxCode',
      //   // 'GST2TaxRate',
      //   // 'TaxAmt',
      //   'ChargesNetAmt',
      //   // 'Remarks',
      //   // 'RemarksHeader',
      //   // 'OrderNo',
      //   // 'DebitAccount',
      //   // 'DebitAccountDesc',
      //   'PayeeCode',
      // ],
      templateDataType: {
        // Before upload (raw from template)
        InvDate: 'date',
        DueDate: 'date',
        Qty: 'number',
        UnitPrice: 'currency',
        ChargesAmt: 'currency',
        AdjustAmt: 'currency',
        GST2TaxRate: 'number',
        TaxAmt: 'currency',
        ChargesNetAmt: 'currency',
        DebitAccount: 'string',

        // After uploaded
        // 'Invoice Date': 'date',
        // 'Due Date': 'date',
        'Unit Price': 'currency',
        'Charges Amt': 'currency',
        'Adjust Amt': 'currency',
        'Tax Rate': 'number',
        'Tax Amt': 'currency',
        'Net Amt': 'currency',
        'Job Charges Amount': 'currency',
        'Job Charges Selling': 'currency',
        'Debit Acc': 'string',
      },

      chargeCodeMapping: {
        DGC: ['DGC', 'DEPOT GATE CHARGE', 'DEPOT HANDLING CHARGE'],
      },

      showSelectCustomTemplate: false,
      selectedExistingTemplate: null,
      existingTemplateErr: '',
      showMappingPopup: false,
      defaultTemplateID: 'AP01', // AP Invoice Import template id
      defaultTemplate: [],
      customTemplateName: '',
      sourceFields: [], // the fields from user's template
      mappedFields: {}, // { `${target}`: `${source}` }
      templateMappingViewMode: false,
      successMessages: [],
      errorMessages: [],

      //Custom Template Listing Popup
      showCustomTemplateListPopup: false,
      showCustomTemplateList: false,
      customTemplateList: [],
      selectedCustomTemplate: [], // use for "Custom Template Listing" popups
      saveCustomTemplateAction: '',

      useExistingTemplateChecked: true,
      createNewTemplateChecked: false,
      isValidatedFullscreen: false,
      showExportMenu: false,
    };
  },
  props: {},
  methods: {
    toggleExportMenu() {
      this.showExportMenu = !this.showExportMenu;
    },

    exportFile(type) {
      this.showExportMenu = false;

      if (type === 'csv') {
        this.downloadExportCSV();
      } else {
        this.downloadExportExcel();
      }
    },
    showMessage: function (type, text) {
      if (text) {
        this.messageBoxTextList.push(text);
      }
      this.messageBoxText = this.messageBoxTextList.join('<br>') || '';
      this.messageBoxType = type || '';
    },

    clearData: function () {
      this.uploadedData = [];
      this.validatedData = [];
      this.formattedUploadData = [];
      this.invTableHeader = '';
      this.importDataHeader = [];
      this.embedSrc = '';
      this.showMessage();
    },

    handleFileUpload: async function (file) {
      this.showMessage();
      this.messageBoxTextList = [];
      this.clearData();

      if (file.length == 0) {
        // No file selected
        this.importDoc['docName'] = '';
        this.importDoc['filetype'] = '';
        this.importDoc['attachmentFile'] = [];
        this.showUploadedDataTable = true;
        this.showValidatedDataTable = true;
        this.$fullscreenLoading();
        return;
      }

      this.importDoc['docName'] = file[0].name;
      this.importDoc['filetype'] = `.${file[0].name.split('.').at(-1)}`.toLowerCase();
      this.importDoc['attachmentFile'] = await file[0].toBase64(true);
      this.importDoc['original'] = file[0];

      if (!this.selectedDocumentType['type'].includes(this.importDoc['filetype'])) {
        const formats = this.documentTypeFilter.map((item) => item['type']).join(',');
        if (formats.includes(this.importDoc['filetype']) && this.importDoc['filetype'] != '.pdf') {
          const confirm = await this.$showAlert(
            'warning',
            `${this.importDoc['filetype']} File Uploaded`,
            `Do you want to upload ${this.importDoc['filetype']} instead of ${this.selectedDocumentType['name']} file?`,
            [{ text: 'Yes' }, { text: 'No', color: 'lightgray' }],
          );

          if (confirm == 'No') {
            this.showMessage(
              'error',
              `Invalid file format. Please provide ${this.selectedDocumentType['name']} (${this.selectedDocumentType['type'].join('/')}) file only. `,
            );
            this.showUploadedDataTable = true;
            return;
          }
          this.selectedDocumentType = this.documentTypeFilter.find((item) =>
            item['type'].includes(this.importDoc['filetype']),
          );
        } else {
          this.showMessage(
            'error',
            `Invalid file format. Please provide ${this.selectedDocumentType['name']} (${this.selectedDocumentType['type'].join('/')}) file only. `,
          );
          this.showUploadedDataTable = true;
          return;
        }
      }

      this.$fullscreenLoading('Uploading File');
      // If PDF, process the PDF file (Doc AI)
      if (this.selectedDocumentType['name'] == 'PDF') {
        this.embedSrc = URL.createObjectURL(file[0]);
        await this.processPDF(file[0]);
        this.$fullscreenLoading();
        return;
      }

      let processedData = [];
      if (this.selectedDocumentType['name'] === 'CSV') {
        processedData = this.csvToObject(this.importDoc);
      } else if (this.selectedDocumentType['name'] === 'Excel') {
        processedData = await this.excelToObject(this.importDoc);
      } else if (this.selectedDocumentType['name'] === 'Text') {
        processedData = this.txtToObject(this.importDoc);
      }
      //console.log(processedData)

      this.showUploadedDataTable = false;
      this.showValidatedDataTable = false;
      if (processedData.length == 0) return;
      this.uploadedData = processedData;
      this.formattedUploadData = processedData;

      // Check if required fields are present in the header
      const requiredFields = this.defaultTemplate
        .filter((field) => field.isRequired == '1')
        .map((field) => field.FieldName);
      const arrayMatch =
        requiredFields.every((val) => this.importDataHeader.includes(val)) && // All required fields are present
        ['ChargesCode', 'DebitAccount'].some((val) => this.importDataHeader.includes(val)); // At least ChargeCode or DebitAcc must be present
      if (!arrayMatch) {
        this.$fullscreenLoading();
        const proceedCustom = await this.$showAlert(
          'warning',
          'Non-default Template Detected',
          'Do you want to use custom template?',
          [{ text: 'Yes' }, { text: 'No', color: 'lightgray' }],
        );

        if (proceedCustom == 'No') {
          const missing = requiredFields.filter((x) => !this.importDataHeader.includes(x));
          this.showMessage(
            'error',
            `Invalid template. Please provide a valid template file. Missing fields: ${missing.join(', ')}`,
          );
          this.showUploadedDataTable = true;
          this.showValidatedDataTable = true;
          return;
        }
        this.useExistingTemplateChecked = this.customTemplateList.length > 0; // default to use existing if have existing template
        this.createNewTemplateChecked = this.customTemplateList.length == 0; // default to create new if no existing template
        this.showSelectCustomTemplate = true;
        return;
      }
      // weishen - 20260129 instead of filtering out empty InvNo records, prompt user warning
      //const filtered = processedData.filter((data) => data['InvNo'] && data['InvNo'].trim() !== '');
      const emptyInvNoRows = processedData.filter((row) => !row['InvNo'] || !row['InvNo'].trim());
      if (emptyInvNoRows.length > 0) {
        this.$fullscreenLoading();

        const proceed = await this.$showAlert(
          'warning',
          'Missing Invoice Number',
          `Invoice No is required. ${emptyInvNoRows.length} record(s) are missing Invoice No. Do you want to continue anyway?`,
          [{ text: 'Yes' }, { text: 'No', color: 'lightgray' }],
        );

        if (proceed === 'No') {
          this.showUploadedDataTable = true;
          return;
        }
      }

      this.$fullscreenLoading('Validating Data');
      this.validatedData = await this.validateImportData(processedData);

      this.$nextTick(() => {
        this.showUploadedDataTable = true;
        this.showValidatedDataTable = true;
      });
      this.$fullscreenLoading();
    },

    handleFileDrop: async function (event) {
      event.preventDefault();

      const files = event.dataTransfer.files;
      if (files.length > 0) {
        await this.handleFileUpload(files);
      }
    },

    csvToObject: function (file) {
      const decode = window.atob(file.attachmentFile);
      //const rows = decode.split('\n').filter(Boolean);
      const rows = [];
      let currentRow = '';
      let insideQuotes = false;

      for (let i = 0; i < decode.length; i++) {
        const char = decode[i];
        if (char === '"') insideQuotes = !insideQuotes;
        // only treat newline as row break when NOT inside quotes
        if (char === '\n' && !insideQuotes) {
          rows.push(currentRow);
          currentRow = '';
        } else if ((char === '\n' || char === '\r') && insideQuotes) {
          continue; // remove newline inside cell
        } else {
          currentRow += char;
        }
      }

      if (currentRow) rows.push(currentRow);

      const cleanRows = rows.filter(Boolean);
      const headers = cleanRows[0].split(',').map((header) => header.trim().replaceAll('"', ''));
      const data = cleanRows.slice(1).map((row) => {
        const values = [];
        let currentField = '';
        let insideQuotes = false;

        for (let i = 0; i < row.length; i++) {
          const char = row[i];

          if (char === '"' && (i === 0 || row[i - 1] !== '\\')) {
            insideQuotes = !insideQuotes;
            // comma inside quotes is not a delimiter
          } else if (char === ',' && !insideQuotes) {
            // If not inside quotes, it's a delimiter; push the field
            values.push(currentField.trim());
            currentField = '';
          } else {
            // else add the character to the current field
            currentField += char;
          }
        }

        // Add the last columns value
        if (currentField !== '') {
          values.push(currentField.trim());
        }

        const obj = {};

        headers.forEach((header, index) => {
          obj[header] = values[index] || '';
        });
        return obj;
      });

      if (data.length == 0) {
        this.showMessage('error', 'CSV file is empty. No data found.');
        return [];
      }

      this.importDataHeader = headers.map((header) => header.replaceAll('"', ''));
      return data;
    },

    txtToObject: function (file) {
      const decode = window.atob(file.attachmentFile);
      const rows = decode.split('\n').filter(Boolean);
      const headers = rows[0].split('\t').map((header) => header.trim());
      const data = rows.slice(1).map((row) => {
        const values = row.split('\t');
        const obj = {};

        headers.forEach((header, index) => {
          obj[header] = values[index] || '';
        });

        return obj;
      });

      if (data.length == 0) {
        this.showMessage('error', 'Txt file is empty. No data found.');
        return;
      }

      this.importDataHeader = headers.map((header) => header.replaceAll('"', ''));
      return data;
    },

    excelToObject: async function (file) {
      const excel = await this.$excelToJson(file.original, false);
      if (!excel.success) {
        this.showMessage('error', 'Please double check your excel file to make sure that it is the right format.');
        return [];
      }

      let temp = [];
      excel.data.forEach((d) => (temp = temp.concat(d.data)));
      if (temp.length == 0) {
        this.showMessage('error', 'Excel file is empty. No data found.');
        return [];
      }
      this.importDataHeader = Object.keys(temp[0]).map((key) => key.replaceAll('"', ''));
      return temp;
    },

    processPDF: async function (file) {
      this.$fullscreenLoading('Processing PDF');
      const formData = new FormData();
      formData.append('file', file);

      try {
        const response = await Axios.post('/InvoiceExtractor/ProcessFile', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });

        // const response = sampleResponse; // for testing

        const keyValueData = response['data']?.['data']?.['keyValue'];
        const headerDetails = keyValueData.filter((data) => data['Key'] != 'Details');
        const invoiceDetails = keyValueData.filter((data) => data['Key'] == 'Details');

        // Validate data right after extracting data
        this.showValidatedDataTable = false;
        const extractedData = this.formatExtractedData(headerDetails, invoiceDetails);
        this.uploadedData = extractedData;
        this.formattedUploadData = extractedData;
        this.$fullscreenLoading('Validating Data');
        this.validatedData = await this.validateImportData(extractedData);

        this.$nextTick(() => {
          this.showValidatedDataTable = true;
        });
      } catch (error) {
        this.$showAlert('error', 'An Error Occurred', error.message);
      } finally {
        this.$fullscreenLoading();
      }
    },

    validateImportData: async function (importData) {
      const toSafeFixed = (value, decimals) => {
        const cleaned = String(value ?? '')
          .replaceAll(',', '') // remove commas
          .replace(/[^0-9.-]/g, '') // remove everything except digits, dot, minus
          .trim();

        const num = parseFloat(cleaned);

        return Number.isFinite(num) ? num.toFixed(decimals) : '';
      };
      const dataToValidate = importData.map((data) => {
        const invoiceDate = data['InvDate'] ? this.formatDate(data['InvDate']) : '';
        return {
          isdetails: data['I'] || 'S',
          invno: data['InvNo'] || '',
          invdate: invoiceDate,
          paymentterm: data['PaymentTerms'] || '',
          duedate:
            data['DueDate'] ? this.formatDate(data['DueDate'])
            : invoiceDate ? this.calculateDueDate(data['PaymentTerms'], invoiceDate)
            : '',
          jobno: data['JobNo'] || '',
          cnno: data['CNNo'] || '',
          contno: data['ContNo'] || '',
          custrefno: data['CustRefNo'] || '',
          currency: data['Currency'] || '',
          exchrate: data['ExchangeRate'] || '',
          chargecode: data['ChargesCode'] || '',
          uom: data['UOM'] || '',
          qty: Number.isFinite(Number(data['Qty'])) ? Number(data['Qty']) : '',
          unitprice: toSafeFixed(data['UnitPrice'], 4),
          chargesamt: toSafeFixed(data['ChargesAmt'], 2),
          adjustamt: toSafeFixed(data['AdjustAmt'], 2),
          taxcode: data['TaxCode'] || '',
          taxrate: Number.isFinite(parseFloat(data['GST2TaxRate'])) ? parseFloat(data['GST2TaxRate']) : '',
          taxamt: toSafeFixed(data['TaxAmt'], 2),
          netamt: toSafeFixed(data['ChargesNetAmt'], 2),
          remarks: data['Remarks'] || '',
          headerremarks: data['RemarksHeader'] || '',
          orderno: data['OrderNo'] || '',
          debitacc: data['DebitAccount'] || '',
          debitaccdesc: data['DebitAccountDesc'] || '',
          payeecode: data['PayeeCode'] || '',
          payeename: data['PayeeName'] || '',
          vehicleno: data['VehicleNo'] || '',
          pono: data['PONo'] || '',
          costcode: data['CostCode'] || '',
        };
      });

      const validated = await this.$apiCallV2('/APInvoiceImport/ValidateAPInvImport', {
        payeetype: this.selectedPayeeType['Party Code'] || '',
        importdata: dataToValidate,
      });

      //console.log(validated)

      if (!Array.isArray(validated) || validated.length === 0) {
        this.$showAlert('error', 'Error Processing Data', 'No validation result returned.');
        return [];
      }
      if (validated[0]?.Results == '1') {
        this.$showAlert('error', `Error Processing Data`, `${validated[0]['ErrMsg']}`);
        return [];
      }

      // validated.forEach((data) => {
      //   const invno = data['Invoice #'];
      //   const details = validated.filter((d) => d['Invoice #'] == invno);
      //   const totalNet = details.reduce((acc, d) => acc + Number(d['Net Amt'] || 0), 0);
      //   const curr = details[0]['Currency'];
      //   data['InvNo'] += ` - Total Amount: ${curr == 'MYR' ? 'RM' : curr} ${this.$currencyFormat(totalNet)}`;
      // });

      const processed =
        validated.some((data) => data['Error'] == '1') ?
          validated.map((data) => {
            if (data['Error'] == '1') {
              return Object.assign({ '': 'https://dsmlib.logistics.systems/Icons/warning.png' }, data);
            }
            return Object.assign({ '': '' }, data);
          })
        : [...validated];

      return processed;
    },

    downloadExportExcel: async function () {
      if (!this.formattedUploadData?.length) return;

      // clean data
      const data = this.formattedUploadData.map((d) => {
        const copy = { ...d };
        delete copy['_rowid'];

        // prevent null/undefined in Excel
        Object.keys(copy).forEach((k) => {
          if (copy[k] === null || copy[k] === undefined) {
            copy[k] = '';
          }
        });
        return copy;
      });

      const invNo = data[0]?.InvNo || 'Export';
      const currentDateTime = new Date().formatString('dd/MM/yyyy HH:mm:ss');
      const exportName = `APInvoiceImport_${invNo}_${currentDateTime}`;

      await this.$jsonToExcel(exportName, data, null, null, false);
    },

    downloadExportCSV: function () {
      const data = this.formattedUploadData.map((d) => {
        const copy = { ...d };
        delete copy['_rowid'];
        return copy;
      });

      if (!data.length) return;

      const columns = Object.keys(data[0]);

      // helper to safely escape CSV
      const escapeCSV = (value) => {
        if (value === null || value === undefined) return '';

        const str = String(value).replace(/[\r\n]+/g, ''); // replace new lines

        // wrap with quotes if contains special chars
        if (/[",\n]/.test(str)) {
          return `"${str.replace(/"/g, '""')}"`;
        }

        return str;
      };

      let outputCSV = '';

      // header
      outputCSV += columns.join(',') + '\r\n';

      // rows
      data.forEach((row) => {
        const rowArray = columns.map((col) => escapeCSV(row[col]));
        outputCSV += rowArray.join(',') + '\r\n';
      });

      // ADD UTF-8 BOM
      const BOM = '\uFEFF';

      const blob = new Blob([BOM + outputCSV], {
        type: 'text/csv;charset=utf-8;',
      });

      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);

      const invNo = data[0]['InvNo'] || 'Export';
      const currentDateTime = new Date().formatString('dd/MM/yyyy HH:mm:ss');

      link.download = `APInvoiceImport_${invNo}_${currentDateTime}.csv`;

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },

    toggleValidatedFullscreen() {
      this.isValidatedFullscreen = !this.isValidatedFullscreen;
    },

    formatExtractedData: function (header, details) {
      //console.log(header);
      //console.log(details);

      const extractCurrency = (curr) => {
        const match = curr.toUpperCase().match(/[A-Z]{3}/);
        return match ? match[0] : curr;
      };

      const extractTerm = (term) => {
        const match = term.match(/\d+/); // Match one or more digits
        return match ? parseInt(match[0], 10) : 0;
      };

      const invoiceNo = (header.find((data) => data['Key'] === 'InvoiceNo')?.['Value'] || '').replace(/[\s\r\n]+/g, '');
      const invoiceDate = header.find((data) => data['Key'] === 'InvoiceDate')?.['Value'] || '';
      const formattedInvoiceDate = invoiceDate ? this.formatDate(invoiceDate) : '';
      let currency = header.find((data) => data['Key'] === 'Currency')?.['Value'] || 'MYR';
      currency = extractCurrency(currency);
      const headerRemarks = header.find((data) => data['Key'] === 'HeaderRemarks')?.['Value'] || '';
      let paymentTerm = header.find((data) => data['Key'] === 'Term')?.['Value'] || '';
      paymentTerm = extractTerm(paymentTerm).toString();
      const invoiceType = header.find((data) => data['Key'] === 'InvoiceType')?.['Value'] || '';
      const payeeName = header.find((data) => data['Key'] === 'CompanyName')?.['Value'] || '';
      const exchRate =
        this.currencyList.find((curr) => curr['Currency Code'] === currency)?.['Currency Rate'] || '1.0000';
      // const dueDate = formattedInvoiceDate && paymentTerm ? new Date(formattedInvoiceDate).addDays(paymentTerm).formatString('yyyy-MM-dd') : '';

      const identifyChargeCode = (charge, headerRemarks) => {
        if (!charge.trim() && !headerRemarks?.trim()) return ''; // if no charge code detected and header empty, return empty
        let identifiedCharge = '';
        Object.keys(this.chargeCodeMapping).forEach((key) => {
          const values = this.chargeCodeMapping[key];
          values.forEach((value) => {
            if (
              charge.toUpperCase().includes(value.toUpperCase()) ||
              headerRemarks.toUpperCase().includes(value.toUpperCase())
            ) {
              identifiedCharge = key;
            }
          });
        });

        switch (
          identifiedCharge // example: if header have word "DGC", read from settingssystem and use the default dgc code
        ) {
          case 'DGC':
            identifiedCharge = this.dgcCode || 'DGC';
            break;

          case 'TOLL':
            identifiedCharge = this.tollCode || 'TOLL';
            break;

          case 'DIESEL':
            identifiedCharge = this.dieselCode || 'DIESEL';
            break;

          default:
            break;
        }

        return identifiedCharge;
      };

      const invoiceData = [];
      //console.log(details);
      for (const data of details) {
        const propertyList = data['Value'] || [];

        if (propertyList.length === 0) continue;
        const containerNo = propertyList.find((item) => item['Key'] === 'ContainerNo')?.['Value'] || '';

        let taxAmount = propertyList.find((item) => item['Key'] === 'TaxAmount')?.['Value'] || '0.00';
        let taxRate = propertyList.find((item) => item['Key'] === 'TaxRate')?.['Value'] || '0';
        taxRate = taxRate.replace('%', '').replace(' ', '');
        let totalExclTax = propertyList.find((item) => item['Key'] === 'TotalExclTax')?.['Value'] || '0.00';
        totalExclTax = totalExclTax.replaceAll(',', '');
        let totalInclTax = propertyList.find((item) => item['Key'] === 'TotalInclTax')?.['Value'] || '0.00';
        totalInclTax = totalInclTax.replaceAll(',', '');

        if (Number(taxRate) > 0 && Number(taxAmount) == 0 && Number(totalExclTax) != 0) {
          taxAmount = (Number(totalExclTax) * Number(taxRate)) / 100;
        }

        if (Number(taxRate) == 0 && Number(taxAmount) == 0) {
          if (Number(totalExclTax) == 0 && Number(totalInclTax) != 0) {
            totalExclTax = totalInclTax;
          } else if (Number(totalInclTax) == 0 && Number(totalExclTax) != 0) {
            totalInclTax = totalExclTax;
          }
        } else if (Number(totalExclTax) == 0 && Number(totalInclTax) != 0) {
          totalExclTax = (Number(totalInclTax) - Number(taxAmount)).toFixed(2);
        } else if (Number(totalInclTax) == 0 && Number(totalExclTax) != 0) {
          totalInclTax = (Number(totalExclTax) + Number(taxAmount)).toFixed(2);
        }

        const vehicleNo = propertyList.find((item) => item['Key'] === 'VehicleRegNo')?.['Value'] || '';
        const chargeCode = propertyList.find((item) => item['Key'] === 'DescriptionCode')?.['Value'] || '';
        const quantity = 1;

        const item = {
          I: 'S', // I: Header; S: Details
          InvNo: invoiceNo,
          InvDate: formattedInvoiceDate,
          PaymentTerms: paymentTerm,
          DueDate: this.calculateDueDate(paymentTerm, formattedInvoiceDate),
          JobNo: '',
          CNNo: '',
          ContNo: containerNo ? this.normalizeContainerNo(this.replaceGreek(containerNo.replaceAll(' ', ''))) : '',
          CustRefNo: '',
          Currency: currency,
          ExchangeRate: Number(exchRate).toFixed(4),
          ChargesCode: identifyChargeCode(chargeCode || invoiceType, headerRemarks) || '',
          UOM: '',
          Qty: quantity,
          UnitPrice: (Number(totalExclTax || 0) / quantity).toFixed(2),
          ChargesAmt: '0.00',
          AdjustAmt: '0.00',
          TaxCode: '',
          GST2TaxRate: Number(taxRate.replace('%', '') || 0),
          TaxAmt: parseFloat(taxAmount || 0).toFixed(2),
          ChargesNetAmt: parseFloat(totalInclTax || 0).toFixed(2),
          Remarks: '',
          RemarksHeader: headerRemarks.substring(0, 200),
          OrderNo: '',
          DebitAccount: '',
          DebitAccountDesc: '',
          PayeeCode: this.selectedPayeeCode ? this.selectedPayeeCode[this.payeeCodeKey] : '',
          PayeeName: this.selectedPayeeCode ? this.selectedPayeeCode[this.payeeCodeDescKey] : payeeName,
          VehicleNo: vehicleNo.replaceAll(' ', '').trim() || '',
          PONo: '',
          CostCode: '',
          // VehicleNo: vehicleNo.replaceAll('SL', '').replaceAll('S/L', '').replaceAll(' ', '').trim() || '',
        };
        invoiceData.push(item);
      }
      //console.log(invoiceData);
      return invoiceData;
    },
    normalizeContainerNo(raw) {
      if (!raw) return '';

      return raw.toUpperCase().replace(/[^A-Z0-9]/g, '');
    },
    revalidateDataClicked: async function () {
      this.$fullscreenLoading('Validating Data');
      this.showValidatedDataTable = false;

      let filtered = this.formattedUploadData;
      if (this.selectedDocumentType['name'] != 'PDF') {
        filtered = filtered.filter((data) => data['InvNo'] && data['InvNo'].trim() !== '');
      }
      this.validatedData = await this.validateImportData(filtered);

      this.$nextTick(() => {
        this.showValidatedDataTable = true;
        this.$fullscreenLoading();
      });
    },

    calculateDueDate: function (term, date) {
      if (!date) return '';
      else if (!term) return new Date(date).formatString('yyyy-MM-dd');

      const termNum = parseInt(term);
      const oriDate = new Date(date);
      const duedate = oriDate.setDate(oriDate.getDate() + termNum);
      return new Date(duedate).formatString('yyyy-MM-dd');
    },

    formatDate: function (datestr) {
      const date = datestr.replace(/\s+\d{1,2}:\d{2}(:\d{2})?(\s?(AM|PM))?$/i, '');

      let detectedFormat = 'yyyy-MM-dd';
      const format = (datestr) => {
        const patterns = [
          { format: 'yyyy-MM-dd', regex: /^\d{2,4}-\d{1,2}-\d{1,2}$/ },
          { format: 'yyyy/MM/dd', regex: /^\d{2,4}\/\d{1,2}\/\d{1,2}$/ },
          { format: 'dd/MM/yyyy', regex: /^\d{1,2}\/\d{1,2}\/\d{2,4}$/ },
          { format: 'dd-MM-yyyy', regex: /^\d{1,2}-\d{1,2}-\d{2,4}$/ },
          { format: 'yyyyMMdd', regex: /^\d{8}$/ },
        ];

        for (const { format, regex } of patterns) {
          if (regex.test(datestr)) {
            detectedFormat = format;
            let [front, back] = ['', ''];
            switch (format) {
              case 'yyyy-MM-dd':
                [, front, back] = datestr.split('-').map(Number);
                if (front > 12 && back <= 12) {
                  detectedFormat = 'yyyy-dd-MM';
                }
                break;

              case 'yyyy/MM/dd':
                [, front, back] = datestr.split('/').map(Number);
                if (front > 12 && back <= 12) {
                  detectedFormat = 'yyyy/dd/MM';
                }
                break;

              case 'dd-MM-yyyy':
                [front, back] = datestr.split('-').map(Number);
                if (back > 12 && front <= 12) {
                  detectedFormat = 'MM-dd-yyyy';
                }
                break;

              case 'dd/MM/yyyy':
                [front, back] = datestr.split('/').map(Number);
                if (back > 12 && front <= 12) {
                  detectedFormat = 'MM/dd/yyyy';
                }
                break;

              case 'yyyyMMdd': {
                // const year = parseInt(datestr.slice(0, 4), 10);
                const month = parseInt(datestr.slice(4, 6), 10);
                const day = parseInt(datestr.slice(6, 8), 10);
                if (month > 12 && day <= 12) {
                  detectedFormat = 'yyyyddMM';
                }
                break;
              }
            }
            break;
          }
        }
        return detectedFormat; // Default format if none match
      };

      let day, month, year;
      switch (format(date)) {
        case 'dd-MM-yyyy':
          [day, month, year] = date.split('-');
          break;

        case 'dd/MM/yyyy':
          [day, month, year] = date.split('/');
          break;

        case 'MM-dd-yyyy':
          [month, day, year] = date.split('-');
          break;

        case 'MM/dd/yyyy':
          [month, day, year] = date.split('/');
          break;

        case 'yyyy-MM-dd':
          [year, month, day] = date.split('-');
          break;

        case 'yyyy/MM/dd':
          [year, month, day] = date.split('/');
          break;

        case 'yyyy-dd-MM':
          [year, day, month] = date.split('-');
          break;

        case 'yyyy/dd/MM':
          [year, day, month] = date.split('/');
          break;

        case 'yyyyMMdd':
          year = date.slice(0, 4);
          month = date.slice(4, 6);
          day = date.slice(6, 8);
          break;

        case 'yyyyddMM':
          year = date.slice(0, 4);
          day = date.slice(4, 6);
          month = date.slice(6, 8);
          break;
      }

      if (year.length < 4) year = 2000 + parseInt(year); // Handle 2-digit year
      return new Date(parseInt(year), parseInt(month) - 1, parseInt(day)).formatString('yyyy-MM-dd');
    },

    removeTag: function (value) {
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = value;
      return tempDiv.textContent;
    },

    saveAPINClicked: async function () {
      if (this.validatedData.some((data) => data['Error'] == '1')) {
        const proceed = await this.$showAlert(
          'warning',
          'There are still some errors in the uploaded data.',
          'Do you want to proceed with the import?',
          [{ text: 'Yes' }, { text: 'No' }],
        );

        if (proceed == 'No') return;
      }

      this.messageBoxText = '';
      this.messageBoxTextList = [];
      if (this.validatedData.length == 0) {
        this.$showAlert('error', 'No data loaded', 'Please upload another file.');
        return;
      }

      const newJC = this.validatedData.filter((data) => data['NewJobChrg'] == '1');
      if (newJC.length > 0) {
        let warningMsg = `The following ${newJC.length} item(s) were not mapped to existing job charges. New job charges will be created. Continue? `;
        let tableString =
          '<table style="width: 100%" border="1"><tr><th>Job #</th><th>Consignment No</th><th>Container No</th><th>Charge Code</th></tr>';

        newJC.forEach((jc) => {
          tableString = `${tableString}<tr><td>${jc['Job #']}</td><td>${jc['Consignment #']}</td><td>${jc['Container #']}</td><td>${jc['Charges Code']}</td></tr>`;
        });
        tableString = `${tableString}</table>`;
        warningMsg = `${warningMsg}\n${tableString}`;

        const buttonOptions = [
          { text: 'Continue', color: 'blue', textColor: 'white' },
          { text: 'Cancel', color: 'gray', textColor: 'white' },
        ];
        const continueSave = await this.$showAlert(
          'warning',
          `${newJC.length} Job Charge(s) Not Mapped!`,
          warningMsg,
          buttonOptions,
        );

        if (continueSave == 'Cancel') {
          this.$fullscreenLoading();
          return;
        }
      }

      this.$fullscreenLoading('Saving AP Invoice');

      let distinctInvNo = this.validatedData.map((d) => d['Invoice #']);
      distinctInvNo = [...new Set(distinctInvNo)];

      const grouped = [];
      distinctInvNo.forEach((invNo) => {
        const set = this.validatedData.filter((d) => d['Invoice #'] === invNo);
        const currencies = [...new Set(set.map((d) => d['Currency']))];
        const localCurrRate =
          this.currencyList.find((curr) => curr['Currency Code'] === this.localCurrency)?.['Currency Rate'] || '1.0000';
        const exchRate =
          currencies.length > 1 ?
            localCurrRate // If multi currency, header currency set to local currency
          : set[0]['Exchange Rate'] ||
            this.currencyList.find((curr) => curr['Currency Code'] === currencies[0])?.['Currency Rate']; // Get exchange rate from master

        const charges = set.filter((d) => !d['Debit Acc'] || d['Debit Acc'] == '');
        const formattedCharges = this.formatCharges(charges);
        const totalCharges = Number(
          formattedCharges.reduce((acc, charge) => acc + Number(charge['netincltax'] || 0), 0),
        );
        const ftotalCharges = Number(
          formattedCharges.reduce((acc, charge) => acc + Number(charge['fnetincltax'] || 0), 0),
        );

        const dp = set.filter((d) => d['Debit Acc'] && d['Debit Acc'] != '');
        const formattedDP = this.formatDP(dp);
        const totalDP = Number(formattedDP.reduce((acc, dp) => acc + Number(dp['netincltax'] || 0), 0));
        const ftotalDP = Number(formattedDP.reduce((acc, dp) => acc + Number(dp['fnetincltax'] || 0), 0));

        const dataToSave = {
          action: 'N',
          apinvtype: '0',
          apinvno: '',
          txntype: '0', // 0-apinv; 1-apcn
          apinvdate: new Date().formatString('yyyy-MM-dd'),
          invno: set[0]['Invoice #'],
          invdate: this.removeTag(set[0]['Invoice Date']),
          payeetype: this.selectedPayeeType ? this.selectedPayeeType['Party Code'] : '',
          payeecode: set[0]['Payee Code'],
          term: set[0]['Payment Terms'],
          duedate: set[0]['Due Date'],
          totalap: (totalCharges + totalDP).toFixed(2), // calc
          ftotalap: (ftotalCharges + ftotalDP).toFixed(2), // calc
          currency: currencies.length > 1 ? this.localCurrency : currencies[0],
          exchrate: Number(exchRate).toFixed(4),
          remark: set[0]['Remarks Header'] || '',
          jobcharges: formattedCharges,
          directposting: formattedDP,
        };

        grouped.push(dataToSave);
      });
      let uploadedCopy = [...this.validatedData];
      this.validatedData = [];
      this.showValidatedDataTable = false;
      this.showSuccessInv = false;

      for (const dataToSave of grouped) {
        const results = await this.$apiCallV2('/APInvoice/SaveAPInvoice', dataToSave);
        if (results[0]['Results'] != 0) {
          this.showMessage(
            'import error',
            `There was an error saving AP Invoice ${dataToSave['invno']}: ${results[0]['ErrMsg']}`,
          );

          uploadedCopy = uploadedCopy.map((ud) => {
            if (ud['Invoice #'] == dataToSave['invno']) {
              return {
                '': 'https://dsmlib.logistics.systems/Icons/error.png',
                ...ud,
                Error: '1',
              };
            }
            return ud;
          });
        } else {
          uploadedCopy = uploadedCopy.filter((ud) => ud['Invoice #'] != dataToSave['invno']);
          const delIndex = this.importSuccessInv.findIndex((f) => f['Invoice #'] == dataToSave['invno']); //delete existing inv no in the importSucessInv table
          if (delIndex != -1) {
            this.importSuccessInv.splice(delIndex, 1);
          }
          this.importSuccessInv.push({
            'AP Invoice #': results[0]['APInv'],
            'Invoice #': dataToSave['invno'],
            'Invoice Date': dataToSave['invdate'],
            'Total Amount': this.$currencyFormat(dataToSave['totalap']),
          });
          this.showMessage('success', `${results[0]['ErrMsg']}`);
        }
      }

      this.$fullscreenLoading();

      this.$nextTick(() => {
        this.validatedData = uploadedCopy;
        this.showValidatedDataTable = true;
        this.showSuccessInv = true;
      });
    },

    formatCharges: function (allCharges) {
      if (allCharges.length == 0) return [];
      const chargesToSave = allCharges.map((charge) => {
        const exchRate = Number(charge['Exchange Rate'] || 1.0);
        const factor = Number(
          this.currencyList.find((curr) => curr['Currency Code'] === charge['Currency'])?.['Factor'] || 1.0,
        );
        const qty = Number(charge['Qty']) || 1;
        let buying = Number(charge['Net Amt'] || 0);

        let unitPrice = Number(charge['Unit Price'] || 0);
        if (unitPrice == 0 && buying !== 0 && qty !== 0) {
          unitPrice = buying / qty;
        } else if (unitPrice != 0 && qty !== 0 && buying == 0) {
          buying = unitPrice * qty; // recalculate buying amount if unit price is provided
        }

        const fbuying = buying * exchRate * factor;
        const funitPrice = fbuying / qty;

        const selling = Number(charge['Job Charges Selling'] || buying);
        const fselling = selling * exchRate * factor;
        const adjAmt = selling == 0 && buying == 0 ? 0 : selling - buying;
        const fadjAmt = adjAmt * exchRate * factor;
        const buyingInclTax = Number(charge['Net Amt'] || buying);
        const fbuyingInclTax = buyingInclTax * exchRate * factor;

        const chargesData = {
          action: 'N', // import all is new
          jobno: charge['FMS Job #'] || '',
          contno: charge['Container #'] || '',
          chargescode: charge['Charges Code'] || '',
          consignmentno: '',
          currency: charge['Currency'] || this.localCurrency,
          exchrate: exchRate.toFixed(4),
          remarks: charge['Remarks'] || '',
          costcode: charge['Cost Code'] || '',
          smkno: '',
          pono: charge['PO No'] || '',
          qty: qty.toString(),
          uom: charge['UOM'] || '',
          unitprice: unitPrice.toFixed(4),
          funitprice: funitPrice.toFixed(4), // need recalculate after incl rate
          amount: buying.toFixed(2),
          famount: fbuying.toFixed(2), // need recalculate after incl rate
          markupamount: adjAmt.toFixed(2),
          fmarkupamount: fadjAmt.toFixed(2), // need recalculate after incl rate
          sellingamount: selling.toFixed(2),
          fsellingamount: fselling.toFixed(2), // need recalculate after incl rate
          taxcode: '',
          taxrate: '0',
          taxableamt: '0.00',
          ftaxableamt: '0.00',
          netincltax: buyingInclTax.toFixed(2),
          fnetincltax: fbuyingInclTax.toFixed(2), // need recalculate after incl rate
          apinvno: '', // only applicable for APCN
          rebateamt: '0.00', // Default 0
          txnguid: '',
          jobchargestxnid: charge['Job Charges TxnID'] || '',
          canceloption: '',
          cmrno: charge['Cust Ref #'] || '',
        };

        return chargesData;
      });
      return chargesToSave;
    },

    formatDP: function (allDP) {
      const dpToSave = allDP.map((dp, index) => {
        const exchRate = Number(dp['Exchange Rate'] || 1.0);
        const factor = Number(
          this.currencyList.find((curr) => curr['Currency Code'] === dp['Currency'])?.['Factor'] || 1.0,
        );

        const amount = Number(dp['Net Amt'] || '0.00');
        const famount = amount * exchRate * factor;
        const amountInclTax = Number(dp['Net Amt'] || '0.00');
        const famountInclTax = amountInclTax * exchRate * factor;
        const jobNo = dp['Job #'] || '';
        const cnNo = dp['Consignment #'] || '';
        const contNo = dp['Container #'] || '';
        const custRefNo = dp['Cust Ref #'] || '';
        const remarks = `${jobNo}/${cnNo}/${contNo}/${custRefNo}/${dp['Remarks'] || ''}`;

        const dpData = {
          action: 'N',
          seqno: index + 1,
          debitac: dp['Debit Acc'] || '',
          creditac: '',
          amount: amount.toFixed(2),
          famount: famount.toFixed(2), // need recalculate after incl rate
          netincltax: amountInclTax.toFixed(2),
          fnetincltax: famountInclTax.toFixed(2), // need recalculate after incl rate
          currency: dp['Currency'] || this.localCurrency,
          exchrate: exchRate.toFixed(4), // chg ltr
          taxdebitac: '', // supposed is company.Co_GST2APGLAcc (txntype = 0)
          taxcreditac: '', // supposed is company.Co_GST2APGLAcc (txntype = 1)
          taxcode: '', // if Company.Co_GST2EffectiveDate <= DocDate && DocDate < Company.Co_GSTEffectiveDate, then TX-0
          taxrate: '0', // Default 0
          taxamount: '0.00', // Default 0
          ftaxamount: '0.00',
          remarks: remarks,
          costcode: dp['Cost Code'] || '',
          vehicleno: dp['Vehicle No'] || '',
          smkno: '', // default empty
          pono: dp['PO No'] || '',
          expenseguid: '',
        };
        return dpData;
      });
      return dpToSave;
    },

    replaceGreek: function (text) {
      const greekToLatinMapCaps = {
        '\u0391': 'A', // Α Greek Alpha
        '\u0392': 'B', // Β Greek Beta
        '\u0395': 'E', // Ε Greek Epsilon
        '\u0396': 'Z', // Ζ Greek Zeta
        '\u0397': 'H', // Η Greek Eta
        '\u0399': 'I', // Ι Greek Iota
        '\u039A': 'K', // Κ Greek Kappa
        '\u039C': 'M', // Μ Greek Mu
        '\u039D': 'N', // Ν Greek Nu
        '\u039F': 'O', // Ο Greek Omicron
        '\u03A1': 'P', // Ρ Greek Rho
        '\u03A4': 'T', // Τ Greek Tau
        '\u03A5': 'Y', // Υ Greek Upsilon
        '\u03A7': 'X', // Χ Greek Chi
      };

      return text.replace(
        /[\u0391\u0392\u0395\u0396\u0397\u0399\u039A\u039C\u039D\u039F\u03A1\u03A4\u03A5\u03A7]/g,
        (ch) => greekToLatinMapCaps[ch] || ch,
      );
    },

    importSuccessButtonClicked: function (btn, data) {
      const action =
        btn == 'Edit' ? 'E'
        : btn == 'View' ? 'V'
        : '';

      const quotationPageLink = this.$router.resolve(
        `/Home/${this.$route.params['user']}/FINPayment/AP%20Invoice?action=${action}&apinvno=${data['AP Invoice #']}&date=${new Date().formatString('yyyy-MM-dd')}`,
      );
      window.open(quotationPageLink.href, '_blank');
    },

    payeeTypeSelected: async function (payeeType) {
      this.$fullscreenLoading('Getting Payee Codes');
      const payeeCodes =
        payeeType ?
          await this.$apiCallV2('/Master/GetDetailsMaster', {
            masterfile: 'payeecode',
            recordid: payeeType['Table'],
          })
        : [];
      if (payeeCodes.length > 0) {
        const codeKeys = Object.keys(payeeCodes[0]);
        this.payeeCodeKey = codeKeys[0];
        this.payeeCodeDescKey = codeKeys[1];

        this.payeeCodeList = payeeCodes.map((payee) => {
          return {
            ...payee,
            'Code - Name': `${payee[codeKeys[0]]} - ${payee[codeKeys[1]]}`,
          };
        });
      }
      this.$fullscreenLoading();
      this.selectedPayeeCode = null;
    },

    //#region Custom Template
    customToDefaultTemplate: async function (mappedFields, data) {
      this.formattedUploadData = [];
      const convertedData = data.map((d) => {
        const getValue = (key) => {
          const fieldKey = mappedFields[key] && mappedFields[key].field ? mappedFields[key].field.key : null;
          const defaultValue = mappedFields[key] ? mappedFields[key].defaultValue : '';
          return (
            fieldKey ?
              fieldKey == '-' ?
                defaultValue
              : d[fieldKey]
            : ''
          );
        };

        const localCurrRate =
          this.currencyList.find((curr) => curr['Currency Code'] === this.localCurrency)?.['Currency Rate'] || '1.0000';

        const netAmount = parseFloat(getValue('ChargesNetAmt') || 0);
        const qty = parseFloat(getValue('Qty') || 1);
        const unitPrice = qty != 0 ? netAmount / qty : 0;

        return {
          I: 'S', // I: Header; S: Details
          InvNo: getValue('InvNo'),
          InvDate: this.formatDate(getValue('InvDate')) || '',
          PaymentTerms: Number(getValue('PaymentTerms')).toString(),
          DueDate: getValue('DueDate'),
          JobNo: getValue('JobNo'),
          CNNo: getValue('CNNo'),
          ContNo: getValue('ContNo'),
          CustRefNo: getValue('CustRefNo'),
          Currency: getValue('Currency') || this.localCurrency,
          ExchangeRate: Number(getValue('ExchangeRate') || localCurrRate).toFixed(4),
          ChargesCode: getValue('ChargesCode'),
          UOM: getValue('UOM'),
          Qty: qty.toString(),
          UnitPrice: unitPrice.toFixed(4),
          ChargesAmt: Number(getValue('ChargesAmt') || '0.00').toFixed(2),
          AdjustAmt: Number(getValue('AdjustAmt') || '0.00').toFixed(2),
          TaxCode: getValue('TaxCode'),
          GST2TaxRate: getValue('GST2TaxRate') || '0', // this field is for GST, not SST
          TaxAmt: Number(getValue('TaxAmt') || '0.00').toFixed(2),
          ChargesNetAmt: netAmount.toFixed(2),
          Remarks: getValue('Remarks').substring(0, 200),
          RemarksHeader: getValue('RemarksHeader').substring(0, 200),
          OrderNo: getValue('OrderNo'),
          DebitAccount: getValue('DebitAccount'),
          DebitAccountDesc: getValue('DebitAccountDesc'),
          PayeeCode: getValue('PayeeCode'),
          PayeeName: getValue('PayeeName'),
          VehicleNo: getValue('VehicleNo'),
          PONo: getValue('PONo'),
          CostCode: getValue('CostCode'),
        };
      });
      this.formattedUploadData = convertedData;

      this.$fullscreenLoading('Validating Data');
      this.validatedData = await this.validateImportData(convertedData);
      this.$nextTick(() => {
        this.showValidatedDataTable = true;
      });
      this.$fullscreenLoading();
    },

    customTemplateClicked: function () {
      this.showCustomTemplateListPopup = true;
    },

    initialiseMappingData: function (customFieldList) {
      this.mappedFields = {};
      const keys = this.defaultTemplate.map((field) => field.key);
      keys.forEach((key) => {
        this.mappedFields[key] = {
          field: null,
          defaultValue: '',
          error: '',
          defaultValueError: '',
        };
      });

      this.sourceFields = customFieldList.map((field) => {
        return {
          key: field,
        };
      });
    },

    customTemplateButtonClicked: async function (button) {
      switch (button) {
        case 'continue': {
          this.showUploadedDataTable = true;
          this.showSelectCustomTemplate = false;

          if (this.createNewTemplateChecked) {
            this.customTemplateName = this.importDoc['docName'];
            this.initialiseMappingData(this.importDataHeader);
            this.saveCustomTemplateAction = 'N';
            this.$nextTick(() => {
              // to ensure popup is shown after data is set
              this.templateMappingViewMode = false;
              this.showMappingPopup = true;
            });
          } else if (this.useExistingTemplateChecked) {
            if (!this.selectedExistingTemplate) {
              this.existingTemplateErr = 'Please select a template to continue.';
              return;
            }
            this.$fullscreenLoading('Getting Template Fields');
            await this.getCustomTemplateFields(this.selectedExistingTemplate['Template Name']);
            this.$fullscreenLoading();
            await this.customToDefaultTemplate(this.mappedFields, this.uploadedData);
          }
          break;
        }

        case 'cancel': {
          this.showSelectCustomTemplate = false;
          this.importDoc['docName'] = '';
          this.handleFileUpload([]);
          break;
        }
      }
    },

    customTemplateChecked: function (event, selection) {
      switch (selection) {
        case 'existing':
          this.createNewTemplateChecked = !event;
          break;

        case 'new':
          this.useExistingTemplateChecked = !event;
          break;
      }
    },

    getCustomTemplateList: async function () {
      this.showCustomTemplateList = false;
      this.$fullscreenLoading('Getting Custom Templates');
      this.customTemplateList = await this.$apiCallV2('/APInvoiceImport/GetCustomTemplateList', {
        defaulttemplateid: this.defaultTemplateID,
      });
      this.$fullscreenLoading();

      this.$nextTick(() => {
        this.showCustomTemplateList = true;
      });
    },

    getCustomTemplateFields: async function (templateName) {
      const fields = await this.$apiCallV2('/APInvoiceImport/GetCustomTemplateFields', {
        defaulttemplateid: this.defaultTemplateID,
        templatename: templateName,
      });

      const customFields = fields
        .filter((field) => field['CustomField'] && field['CustomField'] != '-')
        .map((field) => {
          return field['CustomField'];
        });

      this.initialiseMappingData(customFields);

      const currentMapped = fields.filter((field) => field['ColumnID'] != '');
      const tempMappedFields = this.mappedFields;
      currentMapped.forEach((map) => {
        const key = this.defaultTemplate.find((f) => f.ColumnID == map['ColumnID'])?.key;
        if (key) {
          tempMappedFields[key] = {
            field: map['CustomField'] ? { key: map['CustomField'] } : null,
            defaultValue: map['CustomField'] && map['CustomField'] == '-' ? map['DefaultValue'] : '',
            error: '',
            defaultValueError: '',
          };
        }
      });
      this.mappedFields = { ...tempMappedFields };
    },

    templateListActionButtonClicked: async function (button) {
      switch (button) {
        case 'edit': {
          await this.getCustomTemplateFields(this.selectedCustomTemplate[0]['Template Name']);
          this.customTemplateName = this.selectedCustomTemplate[0]['Template Name'];
          this.showCustomTemplateListPopup = false;
          this.showMappingPopup = true;
          this.saveCustomTemplateAction = 'E';
          this.templateMappingViewMode = false;
          break;
        }
        case 'delete': {
          if (this.selectedCustomTemplate.length == 0) {
            this.$showAlert('warning', 'No template selected', 'Please select a template to delete.');
            return;
          }

          const deleteConfirm = await this.$showAlert(
            'warning',
            'Delete Template',
            `Are you sure you want to delete template <b>${this.selectedCustomTemplate[0]['Template Name']}</b>`,
            [{ text: 'Delete', textColor: 'white', color: 'red' }, { text: 'Cancel' }],
          );

          if (deleteConfirm == 'Cancel') return;

          this.$fullscreenLoading('Deleting Template');
          const results = await this.$apiCallV2('/APInvoiceImport/SaveCustomTemplateMapping', {
            defaulttemplateid: this.defaultTemplateID,
            templatename: this.selectedCustomTemplate[0]['Template Name'],
            action: 'D',
          });
          this.$fullscreenLoading();

          if (results[0].Results !== '0') {
            this.$showAlert(
              'error',
              'Template NOT Deleted',
              `There was an error deleting Template: ${results[0].ErrMsg}`,
              [{ text: 'OK' }],
            );
            return;
          }

          this.$showAlert('success', 'Template Deleted', 'Successfully deleted Template', [{ text: 'OK' }]);
          await this.getCustomTemplateList();
          this.selectedCustomTemplate = [];
          break;
        }
      }
    },

    customTemplateListCloseClicked: function () {
      this.selectedCustomTemplate = [];
      this.showCustomTemplateListPopup = false;
    },

    saveMappingClicked: async function () {
      let error = false;
      Object.entries(this.mappedFields).forEach(([_key, value]) => {
        const field = value.field;
        if (field && field.key == '-' && value.defaultValue.trim() == '') {
          value.defaultValueError = 'Default Value is required';
          error = true;
        }
      });

      if (error) return;

      const checkEmpty = Object.entries(this.mappedFields).every(([_key, value]) => {
        return !value.field;
      });

      if (checkEmpty) {
        this.$showAlert('error', 'No fields mapped', 'Please map at least one field.');
        return;
      }

      // To format default field against custom fields
      const targets = Object.keys(this.mappedFields);
      let allMappings = targets.map((target) => {
        const column = this.defaultTemplate.find((f) => f.FieldName === target);
        return {
          defaultcolumnid: column ? column.ColumnID : '-',
          customfield: this.mappedFields[target].field ? this.mappedFields[target].field.key : '',
          defaultvalue:
            this.mappedFields[target].field && this.mappedFields[target].field.key == '-' ?
              this.mappedFields[target].defaultValue
            : '',
        };
      });
      allMappings = allMappings.filter((m) => m.customfield.trim() != ''); // To only get fields that are mapped

      // Include non-mapped fields with default column id '-'
      const nonMappedFields = this.sourceFields
        .filter((field) => {
          return !allMappings.map((m) => m.customfield).includes(field.key);
        })
        .map((f) => {
          return {
            defaultcolumnid: '-',
            customfield: f.key,
            defaultvalue: '',
          };
        });

      const dataToSave = {
        action: this.saveCustomTemplateAction,
        defaulttemplateid: this.defaultTemplateID,
        templatename: this.customTemplateName,
        mappings: allMappings.concat(nonMappedFields), // Save mapped fields, and other custom fields that does not have mappings
      };

      this.$fullscreenLoading('Saving Template');
      const results = await this.$apiCallV2('/APInvoiceImport/SaveCustomTemplateMapping', dataToSave);
      this.$fullscreenLoading();
      if (results[0]['Results'] != 0) {
        this.$showAlert('error', 'There was an error saving the template mapping.', results[0]['ErrMsg']);
        this.errorMessages.push(results[0]['ErrMsg']);
        return;
      }
      this.successMessages.push(results[0]['ErrMsg']);
      this.templateMappingViewMode = true;
      await this.getCustomTemplateList();
      await this.getCustomTemplateFields(this.customTemplateName);

      if (this.importDataHeader.length > 0 && this.uploadedData.length > 0 && this.validatedData.length == 0) {
        this.showMappingPopup = false;
        await this.customToDefaultTemplate(this.mappedFields, this.uploadedData);
      }
    },
    //#endregion
  },

  async mounted() {
    this.$refs['doctype'].setFocus();

    const mountedPromises = [];
    let mountedPromisesFulfilledCount = 0;

    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'PARTY', module: 'APINV' }).then((result) => {
        this.payeeTypeList = result;
        this.$topLoading(++mountedPromisesFulfilledCount / mountedPromises.length);
      }),
    );

    mountedPromises.push(
      this.$apiCallV2('/APInvoice/GetChargesExpensesListing').then((result) => {
        this.expenseCodeList = result.map((code) => {
          return {
            ...code,
            'Code - Description': `${code['Expenses Code']} - ${code['Description']}`,
          };
        });
        this.$topLoading(++mountedPromisesFulfilledCount / mountedPromises.length);
      }),
    );

    mountedPromises.push(
      this.$apiCallV2(`/SASControl/GetSASControlAccess?system=FINPAYMENT&page=AP Invoice`).then((result) => {
        this.documentType.forEach((a) => {
          const find = result.find((b) => a['key'] == b['Control']);
          if (find) {
            a['hide'] = find['Propertiesvalue'] == 'True';
          }
        });
        this.$topLoading(++mountedPromisesFulfilledCount / mountedPromises.length);
      }),
    );

    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'CURRENCY' }).then((result) => {
        this.currencyList = result;
        this.$topLoading(++mountedPromisesFulfilledCount / mountedPromises.length);
      }),
    );

    mountedPromises.push(
      this.$apiCallV2('/Master/GetSettingsSystem?settingsitem=HMS_DGCEXPCODE').then((result) => {
        this.dgcCode = result[0].SettingsValue;
        this.$topLoading(++mountedPromisesFulfilledCount / mountedPromises.length);
      }),
    );

    mountedPromises.push(
      this.$apiCallV2('/Master/GetSettingsSystem?settingsitem=HMS_TOLLEXPCODE').then((result) => {
        this.tollCode = result[0].SettingsValue;
        this.$topLoading(++mountedPromisesFulfilledCount / mountedPromises.length);
      }),
    );

    mountedPromises.push(
      this.$apiCallV2('/Master/GetSettingsSystem?settingsitem=HMS_DIESELEXPCODE').then((result) => {
        this.dieselCode = result[0].SettingsValue;
        this.$topLoading(++mountedPromisesFulfilledCount / mountedPromises.length);
      }),
    );

    mountedPromises.push(
      this.$apiCallV2('/APInvoiceImport/GetDefaultImportTemplate', {
        system: 'FINPAY',
        templateid: this.defaultTemplateID,
      }).then((result) => {
        const template = result.map((item) => {
          return {
            ...item,
            key: item['FieldName'],
            isRequired: item['Required'],
            // Possibly to have cases where the required fields do not have custom field to map, temporarily remove 'required' and only check if user saves empty template or not
            // required: item['Required'] == '1', // used for template mapping component
          };
        });
        this.defaultTemplate = template.sort((a, b) => Number(a['ColumnID']) - Number(b['ColumnID']));
        this.$topLoading(++mountedPromisesFulfilledCount / mountedPromises.length);
      }),
    );

    await Promise.allSettled(mountedPromises).then(async () => {
      await this.getCustomTemplateList();
      const cocode = (await this.$apiCallV2('/Login/GetDetails'))?.CoCode;
      const companyDetails = (
        await this.$apiCallV2('/Master/GetDetailsMaster', { masterfile: 'COMPANY', recordid: cocode })
      )['Company'];
      this.localCurrency = companyDetails['CompanyLocalCur'];
    });

    const fileInput = document.getElementById('file-input');
    fileInput.addEventListener('dragover', (event) => {
      event.preventDefault();
    });

    fileInput.addEventListener('drop', this.handleFileDrop);

    //#region pane resizer events
    const resizerX = document.getElementById('resizer-x');
    const leftPane = document.getElementById('left-pane');
    const rightPane = document.getElementById('right-pane');
    let isDraggingX = false;

    resizerX.addEventListener('mousedown', () => {
      isDraggingX = true;
      document.body.style.cursor = 'ew-resize';
      document.querySelectorAll('iframe').forEach((iframe) => {
        iframe.style.pointerEvents = 'none'; // Disable pointer events on iframes during resize
      });
    });

    document.addEventListener('mousemove', (event) => {
      if (!isDraggingX) return;
      const offsetLeft = resizerX.parentNode.offsetLeft;
      const pointerX = event.clientX - offsetLeft;
      const min = 100;
      const max = resizerX.parentNode.clientWidth - 100;

      if (pointerX > min && pointerX < max) {
        leftPane.style.width = `${pointerX}px`;
        rightPane.style.width = `calc(100% - ${pointerX + 5}px)`;
      }
    });

    document.addEventListener('mouseup', () => {
      isDraggingX = false;
      document.body.style.cursor = 'default';
      document.querySelectorAll('iframe').forEach((iframe) => {
        iframe.style.pointerEvents = 'auto';
      });
    });

    const resizerY = document.getElementById('resizer-y');
    const topSection = document.getElementById('top-section');
    const bottomSection = document.getElementById('bottom-section');
    let isDraggingY = false;

    resizerY.addEventListener('mousedown', () => {
      isDraggingY = true;
      document.body.style.cursor = 'ns-resize';
    });

    document.addEventListener('mousemove', (event) => {
      if (!isDraggingY) return;
      const offsetTop = resizerY.parentNode.offsetTop;
      const pointerY = event.clientY - offsetTop;
      const min = 100;
      const max = resizerY.parentNode.clientHeight - 100;

      if (pointerY > min && pointerY < max) {
        topSection.style.flex = 'none';
        topSection.style.height = `${pointerY}px`;
        bottomSection.style.height = `calc(100% - ${pointerY + 5}px)`;
      }
    });

    document.addEventListener('mouseup', () => {
      isDraggingY = false;
      document.body.style.cursor = 'default';
    });
    //#endregion
  },
  watch: {
    uploadedData: {
      deep: true,
      handler: function (val) {
        if (val.length == 0) {
          this.validatedData = [];
          this.formattedUploadData = [];
        }
      },
    },

    showMappingPopup: function (val) {
      if (!val) {
        this.selectedCustomTemplate = [];
        this.successMessages = [];
        this.errorMessages = [];
        this.customTemplateName = '';
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.import-main {
  padding: 10px 45px;
  padding-right: 20px;
  font-size: 12px;
  width: 100%;
  display: flex;
  flex-direction: column;

  .top-section {
    background-color: white;
    border-radius: 5px;
    padding: 5px;
    height: max-content;

    .file-input {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      width: 30%;
    }
  }

  .message-container {
    width: 100%;
    height: auto;
    overflow: auto;
    padding: 5px;
    flex-grow: 1;
    margin-left: 20px;
  }

  > .bottom-section {
    align-items: center;
    margin-top: 5px;
    width: 100%;
    height: calc(100% - #{$top-nav-height});

    .top-div {
      height: 75%;
      flex: none;
      display: flex;
      overflow: hidden;

      .top-left-div .top-right-div {
        overflow: auto;
        width: 50%;
        height: 100%;
      }
    }

    .bottom-div {
      height: 25%;
      flex: none;
      overflow: hidden;
    }

    .table-container {
      width: 100%;
      height: 100%;
      padding: 5px;
      background-color: white;
      border-radius: 5px;
    }
  }
}

.resizer-x {
  width: 5px;
  cursor: ew-resize;
}

.resizer-y {
  height: 5px;
  cursor: ns-resize;
}

.pdf-display-condition {
  height: 100%;
  width: 50%;
  padding: 0;
  margin-bottom: 10px;
}

.pdf-display {
  height: 100%;
  width: 100%;
  margin: 0;
  border: 0px;
  margin-bottom: 10px;
  transform: none;
}

.fullscreen-mode {
  height: 100%;
}

.fullscreen-pane {
  position: absolute;
  inset: 0;
  width: calc(100% - 40px) !important;
  height: 100% !important;
  z-index: 50;
  left: 40px;
  background: white;
}

.custom-template-popup {
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background-color: rgba(128, 128, 128, 0.3);
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;

  > .select-container {
    background-color: white;
    border-radius: 5px;
    padding: 10px 20px;
    width: 90%;
    max-width: 400px;

    > .title {
      font-weight: bold;
      text-align: center;
      margin-bottom: 10px;
      font-size: 16px;
    }

    > .continue-buttons {
      width: 100%;
      padding-right: 10px;
      margin-top: 20px;

      > button {
        width: 100%;
        margin-bottom: 3px;
        margin-left: 5px;
      }
    }
  }
}
.export-dropdown {
  position: relative;
  display: inline-block;
}

.export-menu {
  position: absolute;
  top: 100%;
  right: 0;

  background: white;
  border-radius: 5px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);

  overflow: hidden;
  z-index: 100;
}

.export-menu div {
  padding: 6px 14px;
  cursor: pointer;
  white-space: nowrap;
}

.export-menu div:hover {
  background-color: #f2f2f2;
}

.template-list-popup {
  height: calc(100% - #{$top-nav-height});
  width: 100%;
  background-color: rgba(0, 0, 0, 0.3);
  position: fixed;
  top: $top-nav-height;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;

  > .popup-content {
    height: 95%;
    width: 70%;
    background-color: white;
    border-radius: 3px;
    padding: 5px;
    display: flex;
    flex-direction: row;

    > .call-to-action-buttons {
      margin-right: 3px;
      display: flex;
      flex-direction: column;

      > button {
        text-align: left;

        &:not(:first-child) {
          margin-top: 5px;
        }

        > img {
          height: 20px;
          width: 20px;
        }
      }
    }

    > .main-content {
      margin-left: 3px;
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      > .call-to-action-buttons {
        margin-top: 5px;
        display: flex;
        flex-direction: row;
        justify-content: flex-end;

        > button {
          text-align: left;

          &:not(:first-child) {
            margin-left: 5px;
          }

          > img {
            height: 20px;
            width: 20px;
          }
        }
      }
    }
  }
}
</style>
